module.exports = "/images/vendor/vue2vis/dist/editIcon.png?d5422321c4f6feed4081891051f9a6b2";